export const GJENG_INTRO_SEEN_KEY = "join_gjeng_intro_seen";

export type GjengIntroEnvironment = {
  seen: boolean;
  // Once someone is in a gjeng, the concept has explained itself.
  hasGjenger: boolean;
};

export function hasSeenGjengIntro(): boolean {
  try {
    return window.localStorage.getItem(GJENG_INTRO_SEEN_KEY) === "1";
  } catch {
    return false;
  }
}

export function markGjengIntroSeen() {
  try {
    window.localStorage.setItem(GJENG_INTRO_SEEN_KEY, "1");
  } catch {
    // The explainer still closes for the current session if storage is unavailable.
  }
}

export function currentGjengIntroEnvironment(hasGjenger: boolean): GjengIntroEnvironment {
  return {
    seen: hasSeenGjengIntro(),
    hasGjenger
  };
}

// First-time explainer for the Gjenger tab. Shown until the person dismisses
// it or ends up in a gjeng — never both nagging and permanent.
export function shouldShowGjengIntro(environment: GjengIntroEnvironment): boolean {
  return !environment.seen && !environment.hasGjenger;
}
